import { ReducerActions, ReducerState } from './Auth.types';

export const initialState: ReducerState = {
  token: '',
  isLoggedIn: false,
  isLoading: true,
  username: '',
};

export const authReducer = (state: ReducerState, action: ReducerActions) => {
  switch (action.type) {
    case 'CLEAR_CONTEXT':
      return {
        ...state,
        token: '',
        isLoggedIn: false,
        username: '',
      };
    case 'UPDATE_CONTEXT':
      return {
        ...state,
        token: action.payload.token,
        isLoggedIn: action.payload.isLoggedIn,
        username: action.payload.username,
      };
    case 'UPDATE_LOADING':
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
